import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
export function RefreshButton({ queryKeys, label = 'Refresh', className }) {
    const qc = useQueryClient();
    const fetching = useIsFetching();
    const busy = fetching > 0;
    return (_jsxs("button", { type: "button", onClick: () => {
            if (queryKeys?.length) {
                for (const key of queryKeys) {
                    qc.invalidateQueries({ queryKey: key });
                }
            }
            else {
                qc.invalidateQueries();
            }
        }, disabled: busy, className: 'inline-flex items-center gap-1.5 rounded-md border border-input px-3 py-1.5 text-xs font-medium hover:bg-muted disabled:opacity-50 ' +
            (className ?? ''), title: "Re-fetch the latest data from the server", children: [_jsx(RefreshCw, { className: `h-3.5 w-3.5 ${busy ? 'animate-spin' : ''}` }), busy ? 'Fetching…' : label] }));
}
